import { PureLightTheme } from "../../../styles/theme"
import { COLORS } from "../../../styles/variables"

export const TextfieldStyle = {
    minHeight: "42px",
    borderRadius: "12px",
    position: "relative", 
    padding: "0px 50px 0px 0px",
    marginBottom: 2,

    [PureLightTheme.breakpoints.down('md')]: {
        marginBottom: "0px",
        borderRadius: "25px",
    },
    "& textarea": {
        padding: "12px 14px",
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '18px',
        color: COLORS.BLACK,
    },
}

export const BoxIconStyle = {
    position: "absolute",
    top: 0,
    right: 0,
    height: "42px",
    display: "flex",
    alignItems: "center",
    paddingRight: "7px",
}
